<template>
  <div class="pagetopContainer">
    <div class="pagetop">
      <div class="logo">
        <img src="../../assets/images/logo4.png" alt="logo" class="logoImg">
        <!-- <div class="logobar"></div>
        <span class="logotext">智慧实验室管理系统</span> -->
      </div>
      <div class="pagetop-right">
        <div class="inputBox">
          <input type="text" placeholder="请输入仪器名称或编号">
          <button><a-icon type="search" /></button>
        </div>
        <button @click="houtai" class="userbtn"><a-icon type="user" /> 预约系统</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    // 进入后台
      houtai() {
        window.open(`${process.env.VUE_APP_URL}`)
      }
  }
}
</script>

<style lang="less" scoped>
.pagetopContainer {
  // background-color: rgb(86,138,189);
}
.pagetop {
  width: 1200px;
  height: 100px;
  margin: 0 auto;
  // padding: 0 32px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    // width: 590px;
    user-select: none;
    display: flex;
    align-items: center;
    .logoImg {
      width: 560px;
    }
    .logotext {
      font-size: 24px;
      font-weight: 600;
      color: rgb(0,78,161);
    }
    .logobar {
      margin: 0 25px;
      width: 1px;
      height: 40px;
      background-color: #e1e1e1;
    }
  }
  &-right {
    display: flex;
    .inputBox {
      height: 30px;
      display: flex;
      button {
        width: 40px;
        background-color: #004ea1;
        font-size: 14px;
        color: #fff;
        font-weight: 400;
        height: 30px;
        border: 0;
        &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(24,144,255,.2);
          border-color: #40a9ff;
        }
      }
      input {
        width: 202px;
        height: 30px;
        border: 1px solid #999;
        padding-left: 13px;
        &:focus {
          outline: 0;
          box-shadow: 0 0 0 2px rgba(24,144,255,.2);
          border-color: #40a9ff;
        }
      }
    }
    .userbtn {
      margin-left: 10px;
      height: 30px;
      background-color: #004ea1;
      font-size: 14px;
      color: #fff;
      font-weight: 400;
      height: 30px;
      border: 0;
      cursor: pointer;
      &:focus {
        outline: 0;
        box-shadow: 0 0 0 2px rgba(24,144,255,.2);
        border-color: #40a9ff;
      }
    }
    // ::-webkit-input-placeholder { padding-left:13px; }
    // ::-moz-placeholder { padding-left:13px; } /* firefox 19+ */
    // :-ms-input-placeholder { padding-left:13px; } /* ie */
    // input:-moz-placeholder { padding-left:13px; }
  }
}
</style>